import { ReturnRequestDto } from "@babackapp/private-api-client/types";

type GetReturnRequestRefundInitialShippingCostOptions = {
  returnRequest: ReturnRequestDto;
  forceRefundInitialShipping?: boolean;
};

/**
 * Calculates the initial shipping cost refund amount for a return request.
 *
 * The initial shipping amount corresponds to the shipping fees of the order.
 */
export function getReturnRequestRefundInitialShippingCost({
  returnRequest,
  forceRefundInitialShipping = false,
}: GetReturnRequestRefundInitialShippingCostOptions): number {
  const { financial_informations: financialInfo } = returnRequest;
  const { initial_shipping_refunded: initialShipping } = financialInfo;

  if (initialShipping?.method !== "refund") return 0;

  if (forceRefundInitialShipping)
    return Math.max(0, initialShipping.sourceAmount);

  if (initialShipping.presentment_amount <= 0) return 0;

  if (initialShipping.done) return 0;

  return initialShipping.presentment_amount;
}
